var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskLevelDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Risk Level Dot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 301",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#000450"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iUmlza19MZXZlbF9Eb3QiIGRhdGEtbmFtZT0iUmlzayBMZXZlbCBEb3QiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjgiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDggOCI+CiAgPGNpcmNsZSBpZD0iRWxsaXBzZV8zMDEiIGRhdGEtbmFtZT0iRWxsaXBzZSAzMDEiIGN4PSI0IiBjeT0iNCIgcj0iNCIgZmlsbD0iIzAwMDQ1MCIvPgo8L3N2Zz4K";
export { SvgRiskLevelDot as ReactComponent };